import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { select } from 'redux-saga/effects';

export function* watchFbUser() {
    const isVerifiedAccount = yield select(UserSelectors.isVerifiedAccount);
    const userDomain = yield select(UserSelectors.getDomain);
    const queryParams = getQueryParams();

    if (!isVerifiedAccount && userDomain === 'fb') {
        openPopupHelper({
            popupName: popupNames.FACEBOOK_MUST_ATTACH_PHONE,
        });
    } else if (queryParams?.action === 'fb-emergency-dialog' && queryParams.success === '1') {
        openPopupHelper({
            popupName: popupNames.SUCCESS_ATTACH_PHONE,
        });
    }
}
